import PropTypes from "prop-types";
import { Icon } from "@iconify/react";
import menu2Fill from "@iconify/icons-eva/menu-2-fill";
import RefreshFill from "@iconify/icons-eva/refresh-fill";
// material
import { alpha, styled, useTheme } from "@mui/material/styles";
import {
  Box,
  Stack,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Tooltip
} from "@mui/material";
// components
import { MHidden } from "../../components/@material-extend";
//
import AccountPopover from "./AccountPopover";
import { useDashboardTitle } from "./useDashboardTitle";

// ----------------------------------------------------------------------

const DRAWER_WIDTH = 280;
const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 92;

const RootStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: `0 4px 20px ${alpha('#1A73E8', 0.25)}`,
  backdropFilter: "blur(30px)",
  WebkitBackdropFilter: "blur(30px)", // Fix on Mobile
  background: `linear-gradient(135deg, #1A73E8 0%, #34A853 50%, #0D47A1 100%)`,
  borderBottom: `1px solid ${alpha('#4CAF50', 0.3)}`,
  position: 'relative',
  '&:before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '3px',
    background: `linear-gradient(90deg, #E8F5E8 0%, #4CAF50 50%, #E8F5E8 100%)`,
  },
  [theme.breakpoints.up("lg")]: {
    width: `calc(100% - ${DRAWER_WIDTH + 1}px)`,
  },
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  padding: theme.spacing(0, 2),
  [theme.breakpoints.up("lg")]: {
    minHeight: APPBAR_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}));

// ----------------------------------------------------------------------

DashboardNavbar.propTypes = {
  onOpenSidebar: PropTypes.func,
};

export default function DashboardNavbar({ onOpenSidebar }) {
  const title = useDashboardTitle();
  const theme = useTheme();
  return (
    <RootStyle>
      <ToolbarStyle>
        <MHidden width="lgUp">
          <IconButton
            onClick={onOpenSidebar}
            sx={{ 
              mr: 2, 
              color: "white",
              background: `linear-gradient(135deg, ${alpha('#ffffff', 0.15)} 0%, ${alpha('#ffffff', 0.05)} 100%)`,
              borderRadius: 2,
              border: `1px solid ${alpha('#ffffff', 0.2)}`,
              '&:hover': {
                background: `linear-gradient(135deg, ${alpha('#ffffff', 0.25)} 0%, ${alpha('#ffffff', 0.15)} 100%)`,
                transform: 'scale(1.05)',
                boxShadow: `0 4px 12px ${alpha('#ffffff', 0.2)}`,
              },
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            }}
          >
            <Icon icon={menu2Fill} />
          </IconButton>
        </MHidden>

        {/* <Searchbar /> */}

        <Box sx={{ flexGrow: 1 }}>
          <Typography
            variant="h4"
            sx={{
              color: "white",
              fontWeight: 800,
              fontSize: { xs: '1.25rem', sm: '1.5rem', md: '1.75rem' },
              letterSpacing: '-0.5px',
              textShadow: '0 2px 8px rgba(0,0,0,0.3)',
              '&:hover': {
                textShadow: '0 2px 12px rgba(255,255,255,0.4)',
              },
              transition: 'all 0.3s ease',
            }}
          >
            {title}
          </Typography>
        </Box>

        <Stack
          direction="row"
          alignItems="center"
          spacing={{ xs: 1, sm: 2 }}
        >
          {/* <LanguagePopover /> */}
          {/* <NotificationsPopover /> */}
          <Tooltip placement="bottom" title="Reload Page">
            <IconButton 
              onClick={() => (window.location.reload())}
              sx={{
                color: "white",
                background: `linear-gradient(135deg, ${alpha('#ffffff', 0.15)} 0%, ${alpha('#ffffff', 0.05)} 100%)`,
                borderRadius: 2,
                border: `1px solid ${alpha('#ffffff', 0.2)}`,
                '&:hover': {
                  background: `linear-gradient(135deg, ${alpha('#ffffff', 0.25)} 0%, ${alpha('#ffffff', 0.15)} 100%)`,
                  transform: 'scale(1.05)',
                  boxShadow: `0 4px 12px ${alpha('#ffffff', 0.2)}`,
                },
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              }}
            >
              <Icon icon={RefreshFill} />
            </IconButton>
          </Tooltip>
          <AccountPopover />
        </Stack>
      </ToolbarStyle>
    </RootStyle>
  );
}
